import { PayloadAction } from '@reduxjs/toolkit';
import { IBusinessesState } from '.';

export const setElementUpgradeStateHandler = (state: IBusinessesState, action: PayloadAction<{ type: number; state: boolean }>) => {
    if (!state.activeBusiness) return;

    const element = state.activeBusiness.elements.find(element => element.type === action.payload.type);
    if (!element) return;

    element.isAllowUpgrade = action.payload.state;
};
